import { render, staticRenderFns } from "./ReportTypeGroupsRegister.vue?vue&type=template&id=7037561f"
import script from "./ReportTypeGroupsRegister.vue?vue&type=script&lang=js"
export * from "./ReportTypeGroupsRegister.vue?vue&type=script&lang=js"
import style0 from "./ReportTypeGroupsRegister.vue?vue&type=style&index=0&id=7037561f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports